import { CreditCard } from "lucide-react";
import { Card, CardContent } from "../components/ui/card";

/** Master-data placeholder for a future Payment/billing module. */
export function Payments() {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold tracking-tight text-navy">Payment</h1>
        <p className="text-sm text-slate-500">
          Master data pembayaran / billing per brand.
        </p>
      </div>
      <Card>
        <CardContent className="flex flex-col items-center gap-3 py-20 text-center text-slate-400">
          <CreditCard className="h-10 w-10" />
          <p className="text-sm">
            Segera hadir — modul Payment akan tampil di sini.
          </p>
        </CardContent>
      </Card>
    </div>
  );
}
